<div class="row">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12 container-style">
    <form>
      <div class="row">
        <div class="col-lg-8 col-12">
          <app-custom-select [labelText]="'Tipo Doc. Comercial'" [list]="listBussinessDocumentsTypes" [required]="true"
            (onChangeSelect)="getBussinessDocumentsType($event)"></app-custom-select>
        </div>
        <div class="col-lg-4 col-6">
          <app-custom-input-number [labelText]="'Número'" [required]="true"
            (onChangeNumber)="consecutive = $event"></app-custom-input-number>
        </div>
        <div class="col-lg-12 col-6 mt-2 d-flex justify-content-end align-items-end">
          <app-custom-button [title]="'Copiar'" [label]="'Copiar'" [variant]="undefined"
            (onClick)="copyInvoice()"></app-custom-button>
        </div>
      </div>
    </form>
  </div>
</div>